module.exports = __webpack_public_path__ + "static/media/twitter.f02969df.svg";